(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Marquee"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.Marquee-box').fadeIn();
    $('.marquee-new').marquee({
      duration: 30000,
      gap: 20,
      delayBeforeStart: -40000,
      duplicated: true,
      pauseOnHover:true
    });
    
 $('.marquee-new').css('overflow', 'hidden');
}); 

  } catch(e) { console.error(e); }
})();
})();
